import { ClientBalances } from '../modules/prepaid-balances/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import { PageHeader } from './page-title.js';
export function CompanyPrepaidWithdrawalsScreen({
  balanceId,
  onClearBalance,
}: {
  balanceId?: string | undefined;
  onClearBalance?: (() => void) | undefined;
}) {
  const { can, company } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('prepaid_balances.read')}>
      <section className="min-w-0">
        <PageHeader
          trail="Operação / Retiradas de produtos"
          title="Retiradas de produtos"
          description="Encontre o pacote e registre a entrega à pessoa beneficiária."
        />
        <div className="grid gap-6">
          <ClientBalances
            key={balanceId ?? 'all'}
            clientId=""
            balanceId={balanceId}
            onClearBalance={onClearBalance}
            canUse={can('prepaid_balances.use')}
            canAdjust={can('prepaid_balances.adjust')}
            canWithdraw={
              can('prepaid_balances.use') &&
              can('inventory.read') &&
              can('inventory.movements.create')
            }
            activeUnitId={company.activeBusinessUnitId ?? null}
          />
        </div>
      </section>
    </GatedCompanyScreen>
  );
}
